import { ErrorMessage } from "../types";
import { toast } from "../lib/toast";

export const handleApiError = (error: ErrorMessage | undefined, defaultMessage: string) => {
  if (error?.message) {
    const messages = error.message.split(". ");
    messages.forEach(msg => {
      const cleanMsg = msg.replace(/"/g, '');
      toast("error", cleanMsg);
    });
  } else {
    toast("error", defaultMessage);
  }
}; 